import { css } from "styled-components";
import token from "styled-token";
import { overflowAutoMixin } from "../overflowAutoMixin";
import { StyledMask } from "../../components/Mask/Mask";
import { StyledDialog } from "../../components/Dialog/Dialog";
/** @class ModalMixin */

/** @method */

export var ModalMixin = function ModalMixin(props) {
  return token({
    zIndex: "zIndices.modal",
    paddingVertical: "Modal.viewportPaddingVertical",
    paddingHorizontal: "Modal.viewportPaddingHorizontal",
    boxShadow: "shadows.shadow400"
  }, function (tokens) {
    return css(["position:fixed;top:0;left:0;z-index:", ";height:100%;width:100%;", " box-sizing:border-box;padding:", "px ", "px;> ", "{position:fixed;top:0;left:0;height:100%;width:100%;z-index:1;}display:flex;justify-content:center;align-items:center;> ", "", "{z-index:2;box-shadow:", ";}"], tokens.zIndex, overflowAutoMixin(props), tokens.paddingVertical, tokens.paddingHorizontal, StyledMask, StyledDialog, StyledDialog, tokens.boxShadow);
  })(props);
};